import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { RiskAssessmentState, SalesTax } from '@avalara/types/reducer-states';

const initialState: RiskAssessmentState = {
  salestax: null,
};

const store = createSlice({
  name: 'riskAssessment',
  initialState,
  reducers: {
    setRiskAssessmentSalesTax: (state, action: PayloadAction<SalesTax>) => {
      state.salestax = action.payload;
    },
  },
});

export const { setRiskAssessmentSalesTax } = store.actions;

export default store;
